<template>
  <div class="container">
    <div class="d-relative">
      <h1 class="d-inline-flex">Produkte</h1>
      <b-button to="/add_product" variant="primary" v-if="userVendor" class="mt-2 float-right">
        Produkt hinzuf&uuml;gen
      </b-button>
    </div>
    <template  v-if="isFetched && productList.length > 0">
      <div class="w-100 d-flex" style="align-items: center">
        <b-input-group class="mr-2">
          <template #append v-if="search !== ''">
            <b-input-group-text style="cursor: pointer" @click="resetSearch()"><strong class="text-primary">X</strong></b-input-group-text>
          </template>
          <template #append v-if="!isReady">
            <b-input-group-text style="cursor: wait">
              <b-spinner small></b-spinner>
            </b-input-group-text>
          </template>
          <b-form-input @input="searchTable()" :disabled="!isReady" v-model="search" :placeholder="isReady ? 'Produkte suchen ...' : 'Produkte werden geladen ...'"></b-form-input>
        </b-input-group>
        <b-pagination
            class="mt-3"
            v-model="currentPage"
            :total-rows="products.length"
            :per-page="perPage"
            aria-controls="products-table"
        ></b-pagination>
      </div>
      <div class="w-100" style="position: relative">
        <b-checkbox @change="searchTable()" class="mr-1 w-50" v-model="searchZero">Nur Produkte mit Inventar weniger als 10 anzeigen</b-checkbox>
        <p class="float-right absolute mb-0" style="transform: translateY(-20px); right: 15px">Total Produkte: {{ products.length + ' / ' }} {{ productList.length }}</p>
      </div>
      <b-card class="w-100" style="max-width: 100%; overflow-x: auto;">
        <b-table
            style="min-width: 720px"
            id="products-table"
            :items="products"
            :per-page="perPage"
            sort-by="count"
            :sort-desc="false"
            :class="{'show-almost-empty': searchZero}"
            :current-page="currentPage"
            :tbody-tr-class="rowClass"
            :fields="fields">
          <template #cell(index)="data">
            {{ data.count }}
          </template>
          <template #cell(image)="data">
            <b-img :src="data.item.images.length>0?data.item.images[0].url:''" fluid :width="40" :alt="data.title"></b-img>
          </template>
          <template #cell(title)="row">
            <b-link href="#" :data-scroll-id="row.item.id" @click.stop="openProduct(row, $event)">
              {{row.item.title}}
              <feature name="addB2CTag" v-if="row.item.tags.map(tag => tag.toLowerCase()).includes('b2c')">[B2C]</feature>
            </b-link>
          </template>
          <template #cell(inventory)="row">
            <VariantInventoryRow
                v-for="variant in row.item.variants"
                :variant="variant"
                :key="variant.id"
                :currency="shortCurrency"
                @save-inventory="saveVariantInventory">
            </VariantInventoryRow>
          </template>
          <template #cell(delete)="row">
            <DeleteProductButton :productId="row.item.id" :iconOnly="true" />
          </template>
          <slot name="table-busy">
            <div class="page-loader-wrapper" v-if="productList.length === 0" style="position: absolute; transform: translate(-50%, -50%); left: 50%; top: 50%">
              <b-spinner></b-spinner>
            </div>
          </slot>
        </b-table>
      </b-card>
      <b-pagination
          v-model="currentPage"
          :total-rows="products.length"
          :per-page="perPage"
          aria-controls="products-table"
      ></b-pagination>
    </template>
    <b-alert v-else-if="isFetched && productList.length === 0" show>Bisher wurden keine Produkte hinzugefügt.</b-alert>
    <b-alert v-if="isFetched && !userVendor" variant="warning" show>
      Der <b-link to="/profile">Firmename im Profil</b-link> wird vor dem erstellen von Produkten benötigt.
    </b-alert>

    <template>
      <div class="page-loader-wrapper" v-if="!isFetched" style="position: absolute; transform: translate(-50%, -50%); left: 50%; top: 50%">
        <b-spinner></b-spinner>
      </div>
    </template>
  </div>

</template>

<script>
import "firebase/auth";
import {BTable} from "bootstrap-vue";
import VariantInventoryRow from "@/pages/ProductsListPage/VariantInventoryRow";
import DeleteProductButton from "@/components/DeleteProductButton";
import { FeatureToggleComponent as feature } from 'vue-feature-toggle';
import inventory from "@/api/inventory";
import {toNumericId} from "@/api/utils";
import settings from '~config/settings'
import { mapState } from "vuex"

feature.visibility('addB2CTag', (rule) => {
  settings.features.includes(rule.name)
})

export default {
  components: {
      BTable, VariantInventoryRow, DeleteProductButton, feature
  },
  data () {
    return {
      perPage: 10,
      currency: '',
      pageInfo: {},
      products: [],
      searchZero: false,
      fields: [
          {key: 'count', label: 'Index', sortable: true},
          {key: 'image', label: 'Bild'},
          {key: 'title', label: 'Name', sortable: true},
          {key: 'inventory', label: 'Inventar'},
          {key: 'delete', label: 'Löschen'}
          // {key: 'id', label: 'Shop ID'}
      ]
    }
  },
  computed: {
    ...mapState({
        productList: state => state.products.productList,
        isFetched: state => state.products.isFetched,
        isReady: state => state.products.isReady,
        userVendor: state => state.user.profile.vendor || undefined,
        shortCurrency: state => state.products.currency || '',
        listScrollPosition: state => state.products.listScrollPosition || 0,
    }),
    search: {
      get() {
        return this.$store.state.products.search
      },
      set(value) {
        this.$store.commit('products/setSearch', value)
      }
    },
    currentPage: {
      get() {
        return this.$store.state.products.currentPage
      },
      set(value) {
        this.$store.commit('products/setCurrentPage', value)
      }
    }
  },
  created() {
    if (!this.isFetched) {
      this.$store.dispatch('products/fetchProductList')
    }
  },
  mounted() {
    this.products = this.productList
    if (this.search !== '') {
      this.searchTable()
    }
    setTimeout(() => {
      this.scrollto(this.listScrollPosition)
    }, 250)

    if (this.$store.state.user && !this.$store.state.user.active) {
      this.$store.commit('products/setFetched', true)
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.isNew) return 'table-success'
      if (item.isUpdated) return 'table-warning'
    },
    resetSearch() {
      this.search = ''
      this.searchTable()
    },
    searchTable() {
        if (this.searchZero) {
            this.products = this.productList.filter(e => e.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 && e.hasZeroQuantity)
        } else if (this.search !== null && this.search !== '') {
            this.products = this.productList.filter(e => e.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
        } else {
            this.products = this.productList
        }
    },
    scrollto(id) {
      const elems = document.querySelectorAll(`a[data-scroll-id]`) || []
      const arr = [...elems]
      const f = arr.filter(e => e.getAttribute('data-scroll-id') === id)
      if (f.length > 0) {
        f[0].scrollIntoView({behavior: "smooth", block: "center",});
      } else {
        this.$store.commit('products/setListScroll', undefined)
      }
    },
    openProduct(row) {
      const productId = row.item.id;
      this.$store.commit('products/setListScroll', productId)
      this.$router.push('/products/'+productId);
    },
    saveVariantInventory(variant){
      const productId = variant.product.id;
      const product = this.productList.find(p => p.id === toNumericId(productId))
      const vmVariant = product.variants.find(v => v.id === variant.id)
      vmVariant.inventoryQuantity = variant.inventoryQuantity;
      inventory.update(
          productId,
          variant.inventoryItem.id,
          variant.inventoryQuantity,
          variant.inventoryItem.inventoryLevels[0].quantities[0].quantity,
          variant.inventoryItem.inventoryLevels[0].location.id
      ).catch(() => this.$bvModal.show('error-modal'))
    },
  },
}
</script>

<style lang="scss">
  label, legend {
    color: gray;
  }

  table.show-almost-empty tbody .row:not(.almost-empty) {
    display: none !important;
  }
</style>
